(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Form = (function(superClass) {
    extend(Form, superClass);

    function Form(handler, data) {
      var self;
      Form.__super__.constructor.call(this);
      self = this;
      this.question = ko.observable('');
      this.options = ko.observableArray([]);
      this.nominationsAllowed = ko.observable(false);
      this.allowNominations = (function(_this) {
        return function() {
          _this.options([]);
          return _this.nominationsAllowed(true);
        };
      })(this);
      this.disallowNominations = (function(_this) {
        return function() {
          return _this.nominationsAllowed(false);
        };
      })(this);
      this.addOption = (function(_this) {
        return function() {
          return _this.options.push({
            text: ko.observable('')
          });
        };
      })(this);
      this.removeOption = function() {
        return self.options.remove(this);
      };
      this.addOption();
    }

    return Form;

  })(KoModel);

}).call(this);
